import React, { forwardRef } from "react";
import ReactSelect, { components, } from "react-select";

// interfaces
import { SelectMultiProps, SelectSingleProps, SingleSelectOption, SelectRef } from "./ISelect";

// components
import LabelErrorProvider from "../../components/LabelErrorProvider";

// helpers
import { generateSelectStyles, ValueContainer, Option } from "./helpers";

const Select = forwardRef((
  props: SelectSingleProps | SelectMultiProps,
  ref?: SelectRef
) => {
  const {
    label,
    error,
    fullWidth,
    labelPlacement,
    infoTooltipProps,
    closeMenuOnSelect,
    hideSelectedOptions = false,
    isSearchable = false,
    isMulti,
    tooltipInfo,
    menuListTestId,
    onChange,
    wrapperClassName,
    outlined,
    renderOption,
    ...rest
  } = props;

  const styles = generateSelectStyles({ fullWidth, hasError: !!error });

  return (
    <LabelErrorProvider
      label={label}
      error={error}
      labelPlacement={labelPlacement}
      tooltipInfo={tooltipInfo}
      className={wrapperClassName}
      outlined={outlined}
      infoTooltipProps={infoTooltipProps}
    >
      <ReactSelect
        ref={ref}
        isMulti={isMulti}
        styles={styles}
        isSearchable={isSearchable}
        closeMenuOnSelect={typeof closeMenuOnSelect !== "undefined" ? closeMenuOnSelect : !isMulti}
        hideSelectedOptions={hideSelectedOptions}
        components={{
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          ValueContainer,
          Option: (optionProps) => <Option {...optionProps} renderOption={renderOption} />,
          MenuList: ({ children, ...restMenuProps }) => (
            <components.MenuList {...restMenuProps}>
              <div data-testid={menuListTestId}>{children}</div>
            </components.MenuList>
          )
        }}
        onChange={(e, actionMeta) => onChange && onChange(e as SingleSelectOption, actionMeta)}
        {...rest}
      />
    </LabelErrorProvider>
  );
});

Select.displayName = "Select";

export default Select;
